import {ModalBody} from "@/components/modal/index";

const ImageViewModal = ({data, handleCloseModal, modalDepth}) => {
    return(
        <ModalBody>
            <img src={data.files[0].path}/>
        </ModalBody>
    )
}
export default ImageViewModal